import axios from 'axios'
import {APIResponse} from '../../../types/type'
import endpoints from '../../endpoints'
import {BusBrandBase, BusBrandCreatePayload, BusBrandUpdatePayload} from './type'

const API_URL = process.env.REACT_APP_API_URL

export async function fetchBusBrandList(): Promise<APIResponse<BusBrandBase[]>> {
  try {
    const response = await axios.get<APIResponse<BusBrandBase[]>>(API_URL + endpoints.busBrand.list)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function createBusBrand(body: BusBrandCreatePayload) {
  try {
    const response = await axios.post(API_URL + endpoints.busBrand.create, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function updateBusBrand(body: BusBrandUpdatePayload) {
  try {
    const response = await axios.post(API_URL + endpoints.busBrand.update, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function deleteBusBrand(busId: number) {
  try {
    const response = await axios.get(API_URL + endpoints.busBrand.delete + busId)
    return response.data
  } catch (error) {
    throw error
  }
}
